import { ArrowClockwise } from '@phosphor-icons/react';

export default ArrowClockwise;
